export default {
  challenge: (state) => state.challenge,
  challenges: (state) => state.challenges,
  ruletypes: (state) => state.ruletypes,
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  weightTotal: (state) => state.weightTotal,
  challengeName: (state) => state.challengeName,
}
